import React from 'react'
import StateContainer from './StateContainer'

const State = () => <StateContainer data-test="component-tradeIn-state" />

export default State
